import { Record } from 'immutable';
export default Record({
  metadata: null,
  gdpr: null
}, 'DocumentSummaryRecord');